function pop_up (url)
{
  const win1 = window.open(url, "", "width=700,height=600,left=100,top=200,scrollbars=1,resizable=1");
  win1.focus();
}

window.pop_up = pop_up;

export default pop_up;
